var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.5,
    height: 41.5,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "3rz576obda",
    d: "M0 0h44.504v44.504H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.861v24.187c0 .725.293 1.38.775 1.863l13.877-13.934L.775 0A2.619 2.619 0 0 0 0 1.861",
    id: "wh5j2l8y0c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.554%",
    y1: "75%",
    x2: "50.803%",
    y2: "24.999%",
    id: "tkuquwmvbd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.4 .496)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kq9qhqdfjb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3rz576obda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.504 22.252c0 12.29-9.962 22.252-22.252 22.252S0 34.541 0 22.252C0 9.962 9.962 0 22.252 0s22.252 9.963 22.252 22.252",
    fill: "#000",
    mask: "url(#kq9qhqdfjb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m37.359 20.545-4.977-2.874-5.094 5.094 5.094 5.095 4.994-2.885a2.567 2.567 0 0 0 1.243-2.21c0-.91-.465-1.737-1.26-2.22z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.636 8.789)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "glgeyxpgfe",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wh5j2l8y0c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.861v24.187c0 .725.293 1.38.775 1.863l13.877-13.934L.775 0A2.619 2.619 0 0 0 0 1.861",
    fill: "url(#tkuquwmvbd)",
    mask: "url(#glgeyxpgfe)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.288 22.765 5.094-5.094.008-.008-6.826-3.93-8.998-5.289a2.551 2.551 0 0 0-2.62-.052c-.19.12-.363.241-.535.396l13.877 13.977z",
    fill: "#00F076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.411 36.7c.172.154.345.275.535.395.413.224.845.345 1.275.345.466 0 .914-.137 1.328-.379l9.015-5.263 6.826-3.93-.008-.008-5.094-5.095L13.41 36.7z",
    fill: "#F63448"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppGooglePlay);
export default __webpack_public_path__ + "static/media/app_google_play.38671942017ec2fd06f47171b09e5f0c.svg";
export { ForwardRef as ReactComponent };